/* eslint-disable import/prefer-default-export */
export enum Role {
  EntAccountAdmin = 'ent-account-admin',
  SuperAdmin = 'slocoach-super-admin',
  Expert = 'slocoach-expert',
  User = 'slocoach-user',
}
